import Background, { BackgroundType } from '@/Layouts/containers/Background';
import React, { useCallback, useEffect, useState } from 'react';
import { useModal } from 'react-modal-hook';
import PinValidation from '@/Pages/Detail/PinValidation';
import { useHistory } from 'react-router';
import styles from './styles.module.scss';

export interface PinValidationModalProps {
  offerId: string;
  packageName: string;
  packagePrice: string | number;
  collectionId: string;
  origin?: string;
}
const usePinValidationModal = () => {
  const [isVisible, setVisible] = useState(false);
  const [currentPackage, setCurrentPackage] = useState<PinValidationModalProps>(
    {} as PinValidationModalProps,
  );

  const history = useHistory();
  const onClose = useCallback(() => {
    history.goBack();
  }, [history]);

  const [showModal, hideModal] = useModal(
    () => (
      <Background type={BackgroundType.Default} className={styles.modalMask}>
        <PinValidation
          offerId={currentPackage.offerId}
          packageName={currentPackage.packageName}
          packagePrice={currentPackage.packagePrice}
          collectionId={currentPackage.collectionId}
          origin={currentPackage?.origin}
          closeModal={onClose}
        />
      </Background>
    ),
    [currentPackage],
  );

  const openPinModal = useCallback((_pkg: PinValidationModalProps) => {
    setCurrentPackage(_pkg);
    setVisible(true);
  }, []);

  useEffect(() => {
    if (isVisible) {
      showModal();
    } else {
      hideModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (isVisible) {
        event.preventDefault();
        setVisible(false);
      }
    };
    window.addEventListener('popstate', handlePopState);
    if (isVisible) {
      window.history.pushState(null, document.title);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isVisible]);

  return { openPinModal };
};

export default usePinValidationModal;
